import { BlankSlate } from "@msuite/ui/blank-slate";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { OrganizationMembersMenu } from "./organization-members-menu";
import { columns } from "./table-config";

export function OrganizationMembersTable() {
	/** Hooks */
	const { organization } = useAuth();
	const { t } = useTranslation();

	/** Query */
	const { data, isError, isLoading, queryKey, refetch } = useQuery({
		queryKey: ["members"],
		queryFn: async () => {
			if (!organization?.id) return null;
			const response = await client.organizations[":orgId"].members.$get({
				param: {
					orgId: organization?.id,
				},
			});
			const data = await responseHandler(response);
			return data.members;
		},
		retry: false,
		staleTime: 1,
	});

	if (isError)
		/** Render */
		return (
			<BlankSlate
				Icon={() => {
					return (
						<Icon
							name="Shield"
							className="stroke-transparent"
							size={30}
						/>
					);
				}}
				label={t("auth.unauthorized")}
				className="stroke-transparent"
			/>
		);

	/** Render */
	return (
		<DataTable
			data={data ?? []}
			isLoading={isLoading}
			queryKey={queryKey}
			columns={columns}
			persistenceKey="organization-members-table"
			refetch={refetch}
			menu={<OrganizationMembersMenu />}
		/>
	);
}
